import { render, staticRenderFns } from "./DeliveryObject.vue?vue&type=template&id=9d72c1a2&lang=pug&"
import script from "./DeliveryObject.vue?vue&type=script&lang=ts&"
export * from "./DeliveryObject.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports